module.exports = __webpack_public_path__ + "ath_game_web/img/3.3.e8eb798f.png";